import RatingMixin from 'trunks/vue/share/components/fields/rating.js';
import FieldMixinForResponse from './mixin.js';
import LogicalRatingMixin from 'trunks/vue/share/mixins/logic_field/rating.js';

const RatingForResponse = {
  mixins: [
    FieldMixinForResponse,
    RatingMixin,
    LogicalRatingMixin
  ],

  template: `
    <Field :field='field'
           v-show='visible'
           :extendClass='[fieldCommonClass, fieldDifferenceClass]'
           :message='errorMsg'>
      <template slot='input'>
        <div class="rating-list" :class="{ 'readonly': !editing }">
          <div class="rating-item"
               v-for='i in field.maximum'
               :key='i'
               :class="{ active: i <= value }"
               @click='selectValue(i)'>
            <i :class="[ i <= value? 'slp-star' : 'slp-star-o' ]"></i>
          </div>
        </div>
      </template>
    </Field>
  `,

  methods: {
    selectValue: function(i) {
      if (!this.editing) {
        return;
      }
      this.valueChange(this.value === i ? 0 : i);
    }
  }
};

export default RatingForResponse;
